import { render, staticRenderFns } from "./PublicApp.vue?vue&type=template&id=907ca82e&lang=pug&"
import script from "./PublicApp.vue?vue&type=script&lang=js&"
export * from "./PublicApp.vue?vue&type=script&lang=js&"
import style0 from "@/sass/publicApp/main.sass?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports